import { Controller } from 'stimulus';

class InstallationMethodsController extends Controller {
  connect() {
    this.selectedMethod = this.setSelectedMethod();

    this.toggleFields();
  }

  setSelectedMethod() {
    this.selectedMethod = this.methodTargets.find((method) => method.checked)?.value;

    this.toggleFields();
  }

  toggleFields() {
    const isVisible = this.selectedMethod === 'other';

    this.fieldsTarget.hidden = !isVisible;

    this.fieldTargets.forEach((field) => {
      field[isVisible ? 'setAttribute' : 'removeAttribute']('required', true);
    });
  }
}

InstallationMethodsController.targets = [
  'field',
  'fields',
  'method',
];

export default InstallationMethodsController;
